import { isDefined } from '../utils/utils';

// TODO: Move common to `utils.js` or separate files inside `utils` folder

function noop() {
}

function getComputedStyle(el, propName) {
  let styleValue;

  try {
    styleValue = window.getComputedStyle(el, null).getPropertyValue(propName);
  } catch (e) {
    styleValue = document.el.currentStyle[propName];
  }

  return parseFloat(styleValue);
}

function setValueIfExist(obj, propName, value) {
  if (isDefined(value)) {
    obj[propName] = value;
  }
}

/**
 * Checks if popup is blocked
 *
 * @function
 * @name checkIfPopupIsBlocked
 * @param {Object|any} popupWindow - popup window
 * @returns {boolean} - true if popup is blocked, false if popup is not blocked
 */
function checkIfPopupIsBlocked(popupWindow) {
  return !popupWindow || popupWindow.closed || typeof popupWindow.closed === 'undefined';
}

export {
  noop,
  getComputedStyle,
  setValueIfExist,
  checkIfPopupIsBlocked
};
